import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { BaseSettingsSectionComponent } from "../base-settings-section.component";
import { ExtensionSettingsService } from "../extension-settings.service";

/**
 * The automatic Sentence Rewriter card (extension#370 revival, be#772/#828).
 * A deliberate sibling of `FlyrewriteSettingsComponent` (the manual Paragraph
 * Rewriter) — issue #550 / board 24869811 rules these are two separate
 * products with two separate toggles, never one combined control.
 *
 * Default-off by design: unlike Paragraph Rewriter (default enabled), this
 * feature sends typed text to FlyMSG's AI for scoring, so `initialEnabled`
 * defaults to `false` here and the template carries explicit consent copy.
 */
@Component({
    selector: "app-sentence-rewrite-settings",
    templateUrl: "./sentence-rewrite-settings.component.html",
    styleUrls: ["./sentence-rewrite-settings.component.scss"],
    standalone: false
})
export class SentenceRewriteSettingsComponent extends BaseSettingsSectionComponent implements OnInit, OnChanges {
  @Input() initialEnabled = false;

  private lastSavedEnabled: boolean;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: ExtensionSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastSavedEnabled = this.initialEnabled;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialEnabled && !changes.initialEnabled.firstChange) {
      this.lastSavedEnabled = changes.initialEnabled.currentValue;
      if (this.form) {
        this.form.patchValue({ sentenceRewrite: this.lastSavedEnabled }, { emitEvent: false });
        this.markPristine();
      }
    }
  }

  buildForm(): FormGroup {
    return this.fb.group({
      sentenceRewrite: [this.initialEnabled],
    });
  }

  getSaveObservable(): Observable<any> {
    const { sentenceRewrite } = this.form.value;
    this.lastSavedEnabled = sentenceRewrite;
    return this.settingsService.saveSentenceRewrite(sentenceRewrite);
  }

  resetToLastSaved(): void {
    this.form.patchValue({ sentenceRewrite: this.lastSavedEnabled }, { emitEvent: false });
  }

  get sentenceRewriteEnabled(): boolean {
    return this.form?.get("sentenceRewrite")?.value;
  }
}
